import {
  useSalesChannelModeWithSister,
  useSalesChannel,
} from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { get } from 'lodash';
import { SalesChannelModeWithSister } from '@/src/types/common/SalesChannel';
const useSalesChannelWithSisterProductSelectionUuid = () => {
  const mode = useSalesChannelModeWithSister();
  const sc = useSalesChannel();
  const currentUuid = get(sc, 'uuid');
  const sisterSalesChannel = get(sc, 'sisterSalesChannel');
  const sisterSalesChannelUuid = get(sisterSalesChannel, 'uuid');
  if (
    mode === SalesChannelModeWithSister.I_I ||
    mode === SalesChannelModeWithSister.I_Only
  ) {
    return currentUuid;
  } else if (mode === SalesChannelModeWithSister.E_Only) {
    return currentUuid;
  } else if (mode === SalesChannelModeWithSister.I_E) {
    return sisterSalesChannelUuid;
  } else {
    return currentUuid;
  }
};
export { useSalesChannelWithSisterProductSelectionUuid };
